import { Injectable } from '@angular/core';
import { NotificationService } from "@app/core/services/notification.service";
import { HttpClient } from "@angular/common/http";
import { API_URLS } from "@app/core/config/url.config";
import { AuthService } from "@app/core/services/auth.service";
import { ModalService } from "@app/modules/registration/registration-card/auto/services/modal.service";

@Injectable({
  providedIn: 'root'
})
export class WorkingShiftService {

  private remainingMinutes: number = 0;
  private intervalId: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private modalService: ModalService
  ) { }

  public getMinutesUntilEndOfWorkingShift(): void {

    this.clearExistingInterval();

    this.http.get<{ minutesLeft: string; timeShift: number; message: string }>(`${API_URLS.BASE_URL_WORKING_SHIFT}`)
      .subscribe({
        next: (response) => {
          this.remainingMinutes = parseInt(response.minutesLeft, 10);
          this.startCountdown();
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  private startCountdown(): void {

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      this.remainingMinutes--;

      if (this.remainingMinutes === 15) {
        this.modalService.openModal({
          title: "Внимание!",
          body: "Ваша смена заканчивается через 15 минут!",
          confirmText: "Ок",
          cancelText: null,
          onConfirm: () => this.modalService.closeModal(),
          contentTemplate: null,
        });
      }

      if (this.remainingMinutes === 0) {
        this.authService.onLogout();
        clearInterval(this.intervalId);
      }

    }, 60000);
  }

  private clearExistingInterval(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
